import { mapState } from "vuex";
export default {
  data () {
    return {
      parentId: 0, //当前用户组织id
      treeData: [], //树形数据
      departmentName: '',
      remainderPropertyCoin: '',
      statusOptions: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: "normal",
          label: "啟用"
        },
        {
          value: "disable",
          label: "停用"
        }
      ],//组织状态
      status: "", //选中组织状态
      treeLoading: false,
      tableData: [], // 当前组织表格数据
      departmentLoading: false,
      departmentPageIndex: 1,
      departmentPageCount: 10,
      departmentTotal: 0,
      departmentTotalCount: 0,
      // departmentOrder: '',
      // 员工相关变量
      roleOptions: [], //角色选项
      roleId: '',//选中角色id
      staffStatusOptions: [
        {
          value: 0,
          label: "全部"
        },
        {
          label: "啟用",
          value: "normal"
        },
        {
          label: "停用",
          value: "disable"
        }
      ],//员工状态选项
      staffStatus: '', // 选中的员工状态
      staffLoading: false,
      staffTableData: [],
      staffTotal: 0,
      staffTotalCount: 0,
      staffPageIndex: 1,
      staffPageCount: 10
    }
  },
  async created () {
    this.serachRoleInfo();
  },
  mounted () {

  },
  methods: {
    // 获取组织树结构
    async getDepartmentsTree () {
      return new Promise(async (resolve, reject) => { 
        this.treeLoading = true
        let res = await this.axios.get(
          this.pub.getApi().GetDepartmentsTreeByParentID,
          {
            params: {
              departmentID: this.parentId
            }
          }
        );
        // console.log(res);
        this.treeLoading = false
        let { code, message, result } = res.data;
        if (code === 0) {
          this.treeData = [result];
          this.departmentName = result.departmentName;
          this.remainderPropertyCoin = result.remainderPropertyCoin;
          this.remainderDiamond  = result.remainderDiamond
        }
        resolve()
      })
    },
    // 获取组织列表
    async getDepartments (data = {}) {
      // 组别
      if(this.$route.path == '/coin/index'){
        this.pub.userPageSize(this.$store.state.userInfo.accountID,'mcoinInPageCount',this.departmentPageCount) 
      }else{
        this.pub.userPageSize(this.$store.state.userInfo.accountID,'mcoinRePageCount',this.departmentPageCount) 
      }
      this.departmentLoading = true
      let res = await this.axios.post(
        this.pub.getApi().GetDepartments,
        Object.assign(
          {
            parentID: this.departmentId,
            pageIndex: this.departmentPageIndex,
            pageCount: this.departmentPageCount,
            // order: this.departmentOrder || 'createTime'
          },
          data
        )
      );
      // console.log(res);
      this.departmentLoading = false
      let { code, message, result } = res.data;
      if (code === 0) {
        this.tableData = result.data;
        this.departmentTotal = result.count;
        if (Object.keys(data).length === 0) {
          this.departmentTotalCount = result.count;
        }
      }
    },
    // 处理当前页
    handleCurrentChange (val) {
      // console.log(val);
      this.departmentPageIndex = val;
      let data = {};
      if (this.status) {data.status = this.status;}
      if (this.coinNumMin) {data.remainderPropertyCoinStart = this.coinNumMin;}
      if (this.coinNumMax) {data.remainderPropertyCoinEnd = this.coinNumMax;}
      if (this.diamondNumMin) {data.remainderDiamondStart = this.diamondNumMin}
      if (this.diamondNumMax) {data.remainderDiamondEnd = this.diamondNumMax}
      this.getDepartments(data);
    },
    // 处理页码变化
    handleSizeChange (val) {
      // console.log(val);
      this.departmentPageCount = val;
      this.departmentPageIndex = 1;
      let data = {};
      if (this.status) {data.status = this.status;}
      if (this.coinNumMin) {data.remainderPropertyCoinStart = this.coinNumMin;}
      if (this.coinNumMax) {data.remainderPropertyCoinEnd = this.coinNumMax;}
      if (this.diamondNumMin) {data.remainderDiamondStart = this.diamondNumMin}
      if (this.diamondNumMax) {data.remainderDiamondEnd = this.diamondNumMax}
      this.getDepartments(data);
    },
    // 获取员工列表
    async searchCompanyUserInfo (data = {}) {
      let coinMananger = true
      // 员工
      // if(this.$route.fullPath == '/coin/index'){
      if(this.$route.path == '/coin/index'){
        this.pub.userPageSize(this.$store.state.userInfo.accountID,'pcoinInPageCount',this.staffPageCount) 
      }else{
        coinMananger = false
        this.pub.userPageSize(this.$store.state.userInfo.accountID,'pcoinRePageCount',this.staffPageCount) 
      }

      this.staffLoading = true
      let res = await this.axios.post(
        this.pub.getApi().SearchCompanyUserInfo,
        Object.assign(
          {
            departmentID: this.departmentId,
            pageIndex: this.staffPageIndex,
            pageCount: this.staffPageCount,
            coinMananger:coinMananger
          },
          data
        )
      );
      // console.log("userInfo", res);
      this.staffLoading = false
      let { code, message, result } = res.data;
      if (code === 0) {
        this.staffTableData = result.data;
        this.staffTotal = result.count;
        if (Object.keys(data).length === 0) {
          this.staffTotalCount = result.count;
        }
      }
    },
    // 员工页码改变
    handleStaffSizeChange (val) {
      this.staffPageCount = val;
      this.staffPageIndex = 1;
      let data = {};
      if (this.roleId) {data.roleId = this.roleId;}
      if (this.staffStatus) {data.status = this.staffStatus;}
      if (this.staffName) {data.searchName = this.staffName;}
      if (this.staffCoinNumMin) {data.remainderPropertyCoinStart = this.staffCoinNumMin;}
      if (this.staffCoinNumMax) {data.remainderPropertyCoinEnd = this.staffCoinNumMax;}
      if (this.staffDiamondNumMin) {data.remainderDiamondStart = this.staffDiamondNumMin;}
      if (this.staffDiamondNumMax) {data.remainderDiamondEnd = this.staffDiamondNumMax;}
      this.searchCompanyUserInfo(data);
    },
    // 处理当前页面
    handleStaffCurrentChange (val) {
      this.staffPageIndex = val;
      let data = {};
      if (this.roleId) {data.roleId = this.roleId;}
      if (this.staffStatus) {data.status = this.staffStatus;}
      if (this.staffName) {data.searchName = this.staffName;}
      if (this.staffCoinNumMin) {data.remainderPropertyCoinStart = this.staffCoinNumMin;}
      if (this.staffCoinNumMax) {data.remainderPropertyCoinEnd = this.staffCoinNumMax;}
      if (this.staffDiamondNumMin) {data.remainderDiamondStart = this.staffDiamondNumMin;}
      if (this.staffDiamondNumMax) {data.remainderDiamondEnd = this.staffDiamondNumMax;}
      this.searchCompanyUserInfo(data);
    },
    //获取角色信息 
    async serachRoleInfo () {
      // let res = await this.axios.get(this.pub.getApi().SerachChildRoleInfoByParentRoleID + `?parentRoleID=${this.userInfo.roleID}`)
      let res = await this.axios.get(this.pub.getApi().SerachRoleInfoByCompany)
      let { result, code, message } = res.data
      if (code === 0 && result) {
        this.roleOptions = result
      }
    },
    // 获取当前用户信息
    getUserInfo () {
      return new Promise((resolve, reject) => {
        this.axios.get(this.pub.getApi().GetUserInfo).then((res) => {
          let { result, code, message, } = res.data
          if (code === 0) {
            // return result.departmentID
            resolve(result.departmentID)
          } else {
            reject(message)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 组织排序
    // departmentSortChange(row, col) {
    //   console.log(row, col)
    // },
  },
  computed: {
    ...mapState([
      // 映射 this.count 为 store.state.count
      "userInfo"
    ]),
    roleTransition () {
      let data = {}
      this.roleOptions.forEach(item => {
        data[item.roleID] = item.roleName
      })
      return data
    }
  },
  filters: {
    // 状态过滤器
    statusTransition (val) {
      switch (val) {
        case "Normal":
          return "啟用";
          break;
        case "Disable":
          return "停用";
          break;
        default: false;
      }
    },

  }
}